import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'
import Select from 'react-select'

import { validateSearchResults } from '../../../functions'

import SelectForm from '../../rider-input/select-form'

import Switch from '../../../common/switch'

class ListItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      required: false,
      showSelectForm: false,
      showTypeSelectForm: false,
      showDropdown: false,
      showTypeDropdown: false
    }
  }

  componentWillMount() {
    const { required } = this.props

    this.setState({required})
  }

  componentWillReceiveProps(nextProps) {
    const { required } = nextProps

    if (this.props.required !== required) {
      this.setState({required})
    }
  }

  renderDropdown(item, parentItem) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => {
                this.props.addRiderItem({
                  class: "equipment",
                  position: item.children.length+1,
                  parent: item.id,
                  indexes:
                    this.props.parentItemIndex !== undefined
                    ? [
                        this.props.parentItemIndex,
                        this.props.itemIndex,
                        item.children.length
                      ]
                    : [
                        this.props.itemIndex,
                        item.children.length
                      ]
                })
              })}>Add equipment to this instrument</li>
              {/*<li onClick={() => this.setState({showDropdown: false})}>Change channel number</li>*/}
              <li onClick={() => this.setState({showSelectForm: true, showDropdown: false})}>Rename instrument</li>
              <li onClick={() => this.setState({showDropdown: false}, () => {
                parentItem && parentItem.children && parentItem.children.length <= 1
                ? this.props.deleteRiderItem(parentItem.id)
                : this.props.deleteRiderItem(item.id)
              })}>Remove this instrument</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderTypeDropdown(item) {
    const { showTypeDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showTypeDropdown
    })

    return (
      <div className={className}>
        {showTypeDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showTypeDropdown: !showTypeDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showTypeDropdown: !showTypeDropdown})} />

        {
          showTypeDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showTypeSelectForm: true, showTypeDropdown: false})}>Change category</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderEmptyListItem(item, stageElements, options, categories) {
    return (
      <div className="list-item list-item--empty">
        <div className="list-item-handle" />

        <div className="list-item-channel">
          {item.position}
        </div>

        <SelectForm
          group="input"
          item={{
            class: 'instrument',
            parent: item.parent,
            type: item.type
          }}
          itemGroups={this.props.itemGroups}
          position={item.position}
          setFocus={true}
          removeFocus={() => this.props.removeRiderItem(item)}
          createRiderItem={this.props.createRiderItem}
          editRiderItem={this.props.editRiderItem}
          options={
            options
            ? options
            : []
          }
          categories={
            categories
            ? categories
            : []
          }
          createStageElement={this.props.createStageElement}
          searchResults={validateSearchResults(stageElements)}
          getSearchResults={this.props.getSearchResults} />
      </div>
    )
  }

  renderListItem() {
    const { item, parentItem, stageElements, options, categories } = this.props
    const { showSelectForm } = this.state

    const renderSelectForm = (item, stageElements) => (
      <SelectForm
        group={this.props.group}
        item={item}
        itemGroups={this.props.itemGroups}
        position={this.props.position}
        setFocus={true}
        removeFocus={() => this.setState({showSelectForm: false})}
        createRiderItem={this.props.createRiderItem}
        editRiderItem={this.props.editRiderItem}
        options={
          options
          ? options
          : []
        }
        categories={
          categories
          ? categories
          : []
        }
        createStageElement={this.props.createStageElement}
        searchResults={validateSearchResults(stageElements)}
        getSearchResults={this.props.getSearchResults} />
    )

    const renderListMonitorItem = (item, stageElements) => {
      const { required, showTypeSelectForm } = this.state
      const grouped = this.props.dragDropType.indexOf('instrument-group') !== -1

      return (
        <div className="list-monitor-item">
          {this.renderDropdown(item, parentItem)}

          <div className="list-monitor-item--title" onClick={() => this.setState({showSelectForm: true})}>{item.value || (item.member && item.member.name)}</div>

          {
            !grouped && !showTypeSelectForm
            ? this.renderTypeDropdown(item)
            : null
          }

          {
            !grouped
            ? !showTypeSelectForm
              ? <div className="list-monitor-item--type" onClick={() => this.setState({showTypeDropdown: !this.state.showTypeDropdown})}>{item.type.title}</div>
              : <div className="select-form select-form--type">
                  <div className="select-form-escape" onClick={() => this.setState({showTypeSelectForm: false})} />

                  <div className="select-form-fields">
                    <Select
                      autoFocus={true}
                      openOnFocus={true}
                      className="select-form-field"
                      name={`item-type-selector-${item.id}`}
                      value={undefined}
                      valueKey="id"
                      labelKey="title"
                      clearable={false}
                      onChange={(selectedItem) => this.setState({showTypeSelectForm: false}, () => this.props.editRiderItem({id: item.id, type: selectedItem.type.slug}))}
                      categories={[]} />
                  </div>
                </div>
            : null
          }

          <Switch
            required={required}
            toggleSwitch={(required) => this.setState({required}, () => this.props.editRiderItem({id: item.id, required}))} />
        </div>
      )
    }

    return (
      <Draggable draggableId={item.id} type={this.props.dragDropType}>
        {(provided, snapshot) => (
          <div className="list-item">
            <div className="list-item--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle} >
              <div className="list-item-handle" {...provided.dragHandleProps} />

              <div className="list-item-channel">
                {item.position}
              </div>

              {
                showSelectForm
                ? renderSelectForm(item, stageElements)
                : renderListMonitorItem(item, stageElements)
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { item } = this.props

    return item.id !== undefined
    ? this.renderListItem()
    // : this.renderEmptyListItem(item, stageElements, options, categories)
    : null
  }
}

ListItem.propTypes = {
  dragDropType: PropTypes.string,
  group: PropTypes.string,
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  parentItem: PropTypes.object,
  parentItemIndex: PropTypes.number,
  position: PropTypes.number,
  required: PropTypes.bool,
  setFocus: PropTypes.bool,
  itemGroups: PropTypes.array,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  options: PropTypes.array,
  categories: PropTypes.array,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

ListItem.defaultProps = {
  dragDropType: '',
  group: '',
  item: {},
  itemIndex: undefined,
  parentItem: {},
  parentItemIndex: undefined,
  position: 0,
  required: false,
  setFocus: false,
  itemGroups: [],
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  options: undefined,
  categories: undefined,
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-list/list-item.js